<!--  -->
<template>
  <div class="quick-login">
    <ShowGift :isGift="isGift" :newUserData="newUserData" @closeNewUser="closeNewUser" />
    <ChooseRecords v-if="isYearTabBox" @closeChooesRecords="closeYearBox" />
    <RegisterAfter @closeRegisterAfter="closeRegisterAfter" ref="registerAfter" />
  </div>
</template>

<script>
import { GetQueryValue } from '@/utils/tools';
import { phoneLogin } from '@/api/login/index';
import { reqNowAcvitity } from '@/api/newUser';
import ShowGift from '@/pages/newUserRegister/components/showGift.vue';
import ChooseRecords from '@/components/login/chooseRecords.vue';
import RegisterAfter from '@/components/login/registerAfter.vue';

export default {
  components: {
    ShowGift,
    ChooseRecords,
    RegisterAfter,
  },
  data() {
    return {
      fromPath: '',
      urlParams: '',
      pagesParams: '',
      pravieStatus: false,
      pullNewPage: this.$route?.query?.redirect?.indexOf('pullnew') > -1, // 判断是否是拉新页面来的
      isYearTabBox: false,
      isGift: false, // 是否展示新人注册有礼
      // haveGift: false, // 是否有新人注册活动
      newUserData: {}, // 新人注册活动数据
      address: '', // 注册地址
      sourceType: 17, // 直接流量 17
      logo: require('@/assets/img/loginImg/login.png'),
      operater: this.$route?.query?.operater,
      searchUrl: decodeURIComponent(window.location.search.substring(1)),
    };
  },
  computed: {},
  watch: {},
  methods: {
    // 查询新人注册活动
    async reqNewUser() {
      // 来源真题实战则不展示新人有礼活动
      const questionSourceType = GetQueryValue('questionSourceType');
      if (Number(questionSourceType) === 1) {
        this.livePage();
        return;
      }
      const { code, data } = await reqNowAcvitity();
      if (code === 0 && data) {
        this.isGift = true;
        // this.haveGift = true;
        this.newUserData = data;
      } else {
        this.livePage();
      }
    },
    closeNewUser() {
      this.isGift = false;
      this.livePage();
    },
    livePage() {

      if (
        this.$route?.query?.redirect?.indexOf('question') > -1 ||
        this.$route?.query?.redirect?.indexOf('cet') > -1 ||
        this.$route?.query?.redirect?.indexOf('mockExam') > -1||
        this.$route?.query?.redirect?.indexOf('gfxt') > -1||
         this.$route?.query?.redirect?.indexOf('iform') > -1
      ) {
        const routeUrl = this.$router.resolve({
          path: this.$route.query.redirect,
          query: JSON.parse(this.urlParams),
        });
        window.location.href = routeUrl.resolved.fullPath;
      } else if (this.$route.query.redirect) {
        this.$router.replace({
          path: this.$route.query.redirect,
          query: JSON.parse(this.urlParams),
          params: JSON.parse(this.pagesParams),
        }); // 这里是拦截前想跳转的页面
      } else {
        this.$router.replace('/home');
      }
    },
    closeRegisterAfter() {
      if (this.pullNewPage) {
        this.livePage();
      } else if (this.$route.query.isChoose) {
        // 如果是个人中心 登录/注册按钮来的  就显示
        this.isYearTabBox = true;
      } else {
        this.reqNewUser();
      }
    },
    // 关闭选择年份弹框
    closeYearBox() {
      setTimeout(() => {
        this.isYearTabBox = false;
        // 进入新人专区页面
        this.$router.push({
          path: '/newZone',
        });
      }, 1500);
    },
    getOS() {
      // 获取当前操作系统
      let os;
      if (
        navigator.userAgent.indexOf('Android') > -1 ||
        navigator.userAgent.indexOf('Linux') > -1
      ) {
        os = 'Android';
      } else if (navigator.userAgent.indexOf('iPhone') > -1) {
        os = 'iOS';
      } else if (navigator.userAgent.indexOf('Windows Phone') > -1) {
        os = 'WP';
      } else {
        os = 'Others';
      }
      return os;
    },
    async submit(loginToken) {
      const { code, msg, data } = await phoneLogin({
        loginType: 4,
        clientType: 3,
        os: this.getOS(),
        loginTerminal: 5,
        terminal: 5,
        loginToken,
        sourceType: this.sourceType,
        address: window.location.origin + this.address, // 地址
        registerPlatform:this.$root.miniprogram?5:2,
      });
      if (code === 0) {
        this.$toast('登录成功');
        window.localStorage.setItem('accessToken', data.token);
        let pullNewPageHelp = this.$route?.query?.redirect?.indexOf('help') > -1; // 判断是否是拉新落地页来的
        if (this.$route?.query?.redirect?.indexOf('helpList') > -1) {
          pullNewPageHelp = false;
        }
        this.$root.getUserInfo().then((user) => {
          // 个人中心注册的不收集，新增 isChoose 判断
          if (data?.isNewUser) {
            if (this.$route.query.isChoose && !this.pullNewPage) {
              this.isYearTabBox = true;
            } else if (this.pullNewPage && pullNewPageHelp) {
              // 拉新落地页不弹23/34选择考季
              this.$refs.registerAfter.showPop = false;
              this.livePage();
            } else {
              this.$refs.registerAfter.showPop = true;
            }
            // this.$refs.registerAfter.showPop = true;
            // if (this.$route.query.isChoose) {
            //   // 如果是个人中心 登录/注册按钮来的  就显示
            //   this.isYearTabBox = true;
            // } else {
            //   this.reqNewUser();
            // }
            this.send_registerSuccess_event('一键登录', user.phone, user.userCode);
            this.send_loginSuccess_event('一键登录', user.phone);
          } else {
            this.livePage();
            this.send_loginSuccess_event('一键登录', user.phone);
          }
        });

        this.$store.dispatch('saveUserPhone', '');
        window.localStorage.removeItem('pagesQuery');
        window.localStorage.removeItem('pagesParams');
      } else {
        this.$toast(msg);
        // this.$root.showQuickLogin = '';
        // this.$router.replace({
        //   path: '/registrationLogin',
        //   query: JSON.parse(this.urlParams),
        //   pagesParams: JSON.parse(this.pagesParams),
        // });
        this.loginAuth();
      }
    },
    /* eslint-disable */
    // gio注册埋点
    send_registerSuccess_event(registerMethod, mobilePhone, id) {
      let extraInfo = {}
      if (this.sourceType == 39) {
        extraInfo = {
          userSource_var: '模考邀请场',
          landingPage_var: this.$route?.query?.redirect,
        }
      }
      gio('setUserId', id);
      gio('track', 'registerSuccess_event', {
        registerMethod_var: registerMethod, // 注册方式
        mobilePhone_var: mobilePhone, // 手机号
        platform_var: 'H5',
        ...extraInfo
      });
    },
    // gio登录埋点
    send_loginSuccess_event(loginMethod, mobilePhone) {
      gio('people.set', 'userPhone', mobilePhone);
      gio('track', 'loginSuccess_event', {
        loginMethod_var: loginMethod,
        mobilePhone_var: mobilePhone,
        platform_var: 'H5',
      });
    },
    JVerificationInterfaceFit(){
      const that = this;
      that.addEventListen(); // 绑定事件
      that.setUi(); // 设置UI
      window.JVerificationInterface.loginAuth({
        operater: this.operater,
        success: (login) => {
          console.log(login, '一键登录成功');
          that.submit(login?.content);
        },
        fail: (fail) => {
          const { content } = fail;
          console.log(fail, '‘一键登录失败');
          if (content?.[this.operater]?.indexOf('3001') > -1) {
            // 关闭页面
            that.closePage();
          } else if (content?.[this.operater]?.indexOf('3007') > -1) {
            // 其他方式登录
            that.otherLogin();
          } else if (content?.[this.operater]?.indexOf('105025') > -1){
            // 号码输错超限制（3次）
            that.otherLogin();
          }else {
            that.otherLogin()
          }
        },
      });
    },
    loginAuth() {
      this.JVerificationInterfaceFit()
    },
    addEventListen() {
      const that = this;
      window.JVerificationInterface.addEventListen({
        event: (data) => {
          const { code } = data;
          switch (code) {
            case 3001:
              // 关闭页面;
              that.closePage();
              break;
            case 3002:
              // 已同意协议;
              that.pravieStatus = true;
              break;
            case 3003:
              // 未同意协议;
              that.pravieStatus = false;
              break;
            case 3006:
              // 点击登录;
              // that.submit();
              break;
            case 3007:
              // 其他登录按钮;
              that.otherLogin();
              break;
            default:
          }
        },
      });
    },
    setUi() {
      const that=this;
      window.JVerificationInterface.setCustomUIWithConfig({
        logo:  require('../../assets/img/loginImg/login.png'),
        appName: '启航教育',
        loginBtnColor: '#ff7f41',
        loginTextColor: '#fff',
        customPolicyLink1: ['《用户协议》', 'https://mobile.iqihang.com/ark/registeredapp'],
        customPolicyLink2: ['《隐私政策》', 'https://mobile.iqihang.com/zt/privacy_app/index.html'],
        customPolicyLink3: [],
        customPolicyLinkColor: '#ff7f41',
        isDisplayOtherWayBtn: true,
        customOtherWayText: '其他手机号码登录',
        customOtherWayTextColor: '#A5A5A5',
      });
    },
    closePage() {
      this.$root.showQuickLogin = false;
      // 对于来自b站订单发货的，直接返回上一级
      if (this.fromPath === '/bilibili-shipments/1') {
        this.$router.back();
      } else if(this.$route?.query?.redirect?.indexOf('question') > -1){
        this.otherLogin()
        return;
      } else if (this.fromPath === '/' || this.fromPath === '' || window.history.length < 3) {
        const questionSourceType = GetQueryValue('questionSourceType');
        if (Number(questionSourceType) === 1) {
          const routeUrl = this.$router.resolve({
            path: this.$route.query.redirect,
            query: JSON.parse(this.urlParams),
          });
          window.location.href = routeUrl.resolved.fullPath;
          return;
        }
        this.$router.replace('/home');
      } else {
        this.$router.back();
      }
      this.$store.dispatch('saveUserPhone', '');
      window.localStorage.removeItem('pagesQuery');
      window.localStorage.removeItem('pagesParams');
    },
    otherLogin() {
      this.$root.showQuickLogin = false;
      this.$router.replace({
        path: '/registrationLogin',
        query: JSON.parse(this.urlParams || '{}'),
        pagesParams: JSON.parse(this.pagesParams || '{}'),
      });
    },
    dealUrlData(data) {
      const query = decodeURIComponent(window.location.search.substring(1));
      if (this.$route?.query?.free === '1') {
        this.address = query.replace(`free=1&redirect=/${data}&`, `/ark/${data}?`);
      } else {
        this.address = query.replace(`redirect=/${data}&`, `/ark/${data}?`);
      }
    },

    getSourceType() {
      const { redirect } = this.$route?.query;
      if (redirect?.indexOf('pullnew') > -1) {
        // 拉新活动
        this.sourceType = 1;
        this.dealUrlData('pullnew/home');
      } else if (redirect?.indexOf('receiveCoupon') > -1) {
        // 领取优惠券
        this.sourceType = 6;
        this.dealUrlData('receiveCoupon');
      } else if (redirect?.indexOf('combinationCourse') > -1) {
        // 付费课程(套餐)
        this.sourceType = 5;
        this.dealUrlData('combinationCourse');
      } else if (redirect?.indexOf('courseDetail') > -1) {
        if (this.$route?.query?.free === '1') {
          // 免费课程0元课程
          this.sourceType = 4;
        } else {
          // 付费课程
          this.sourceType = 5;
        }
        this.dealUrlData('courseDetail');
      } else if (redirect?.indexOf('drawLots') > -1) {
        // 运营活动抽奖
        this.sourceType = 2;
        if (this.$route?.query?.has === 'false') {
          this.address = this.searchUrl.replace('has=false&redirect=/drawLots', '/ark/drawLots');
        } else {
          this.address = this.searchUrl.replace('has=true&redirect=/drawLots&', '/ark/drawLots?');
        }
      } else if (redirect?.indexOf('question') > -1) {
        const questionSourceType = GetQueryValue('questionSourceType');
        if (Number(questionSourceType) === 1) {
          //  questionSourceType:
          // 1：真题实战:sourceType-20
          // 2：题库登陆:sourceType- 待定
          this.sourceType = 20;
          this.address = this.searchUrl.replace(
            'redirect=/question/questionList&',
            '/question/questionList?',
          );
        }
      }  else if (redirect?.indexOf('businessOrder') > -1) {
        // 电商订单
        this.sourceType = 25;
        this.dealUrlData('businessOrder');
      } else if (redirect?.indexOf('examOutline') > -1) {
        // 电商订单
        this.sourceType = 29;
      }else {
        // 直接流量
        this.sourceType = 17;
        this.address = '';
      }
    },
    // 如果三秒内还不出现登录的ui，则回到常规登录页面
    handleErrpage(){
      const that = this;
      setTimeout(()=>{
        const cmDom = document.getElementById('cmiframe'); // 移动
        const ctDom = document.getElementById('fjs_auth_iframe'); // 电信
        if (!cmDom && !ctDom) {
          if (cmDom) {
            cmDom.parentNode.removeChild(cmDom);
          }
          if (ctDom) {
            ctDom.parentNode.removeChild(ctDom);
          }
          that.otherLogin();
        }
      },3000)
    },
  },
  created() {
    this.loginAuth();
    this.getSourceType();
    this.urlParams = window.localStorage.getItem('pagesQuery');
    this.pagesParams = window.localStorage.getItem('pagesParams')
      ? window.localStorage.getItem('pagesParams')
      : null;
  },
  mounted() {
    document.getElementsByClassName('app')[0].setAttribute('style', 'height: 100%');
    this.handleErrpage()
  },
  beforeDestroy() {
    document.getElementsByClassName('app')[0].removeAttribute('style');
  },
  beforeRouteEnter: (to, from, next) => {
    next((vm) => {
      vm.fromPath = from.path;
    });
  },
};
</script>
<style lang="scss" scoped>
.quick-login {
  width: 100%;
}
</style>
